import { AnswersEntity, Order } from "./interfaces/eventbrite";

const clientUri =
  "https://abwk365dm9.execute-api.us-east-2.amazonaws.com/client/eb";

export type EventBriteUser = {
  email: string;
  first_name: string;
  last_name: string;
};

const parseEBOrderQuestionAnswers = (answers: AnswersEntity[]) => {
  const res = {} as Record<string, string>;
  answers.forEach((answer) => {
    res[answer.question] = answer.answer;
  });
  return res;
};

const useriteOrder = (order: Order): EventBriteUser[] => {
  const registrant = {
    email: order.email,
    first_name: order.first_name,
    last_name: order.last_name,
  };

  const attendees =
    order.attendees?.map((attende) => {
      const { addresses, ...profile } = attende.profile;
      return {
        addresses: addresses.toString(),
        ticket_class_name: attende.ticket_class_name,
        ...profile,
        ...parseEBOrderQuestionAnswers(attende?.answers || []),
      };
    }) || [];
  return [registrant, ...attendees];
};

export const getOrder = async (orderId: string) => {
  const url = `${clientUri}/orders/${orderId}/?expand=attendees`;
  try {
    const resp = await fetch(url);
    if (resp.status !== 200) {
      throw new Error(
        `Got status code ${resp.status} instead of 200. ${resp.statusText}`
      );
    }
    return (await resp.json()) as Order;
  } catch (error) {
    throw new Error(`Failed to get order details from Eventbrite.`);
  }
};

export const getEventbriteUsersFromOrder = async (orderId: string) => {
  const order = (await getOrder(orderId)) as Order;
  return useriteOrder(order);
};
